<template></template>

<script>
  // import VueApexCharts from "vue-apexcharts";

  import { mapGetters } from "vuex";

  export default {
    components: {},
    computed: {},
    props: {
      source: String,
    },
    data: () => ({}),
    mounted() {},
    methods: {},
  };
</script>
